/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomerTypeModel,
  Forbidden,
  IoTVendorCategoryResponseModel,
  IoTVendorFilterModel,
  IoTVendorPostModel,
  IoTVendorPutModel,
  IoTVendorResponseModel,
  IoTVendorResponseSimpleModel,
  IoTVendorTenantPutModel,
  IoTVendorTenantsResponseModel,
  NotFound,
  TenantAffiliateAddModel,
  TenantAffiliateFilterModel,
  TenantAffiliateResponseModel,
  TenantAllocationsFilterModel,
  TenantAllocationsResponseModel,
  Unauthorized,
} from '../models';

export interface SettingsAddTenantAffiliateAssignmentRequest {
    tenantAffiliateAddModel?: TenantAffiliateAddModel;
}

export interface SettingsCreateVendorRequest {
    ioTVendorPostModel?: IoTVendorPostModel;
}

export interface SettingsDeleteTenantAffiliateAssignmentRequest {
    id: string;
}

export interface SettingsDeleteVendorRequest {
    vendorId: string;
    replacementVendorId: string;
}

export interface SettingsGetTenantAffiliateAssignmentsRequest {
    filter?: TenantAffiliateFilterModel;
}

export interface SettingsGetTenantAllocationsByFilterRequest {
    filter?: TenantAllocationsFilterModel;
}

export interface SettingsGetTenantVendorAllocationRequest {
    vendorId: string;
}

export interface SettingsGetVendorsRequest {
    filter?: IoTVendorFilterModel;
}

export interface SettingsTenantVendorAllocateRequest {
    vendorId: string;
    ioTVendorTenantPutModel?: IoTVendorTenantPutModel;
}

export interface SettingsUpdateTenantAffiliateAssignmentRequest {
    id: string;
    tenantAffiliateAddModel?: TenantAffiliateAddModel;
}

export interface SettingsUpdateVendorRequest {
    vendorId: string;
    ioTVendorPutModel?: IoTVendorPutModel;
}

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI {

    /**
     * Ad tenant affiliate for a specific country
     */
    async settingsAddTenantAffiliateAssignmentRaw(requestParameters: SettingsAddTenantAffiliateAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantAffiliateResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/tenant-affiliate-assignment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.tenantAffiliateAddModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Ad tenant affiliate for a specific country
     */
    async settingsAddTenantAffiliateAssignment(requestParameters: SettingsAddTenantAffiliateAssignmentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantAffiliateResponseModel> {
        const response = await this.settingsAddTenantAffiliateAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a vendor
     */
    async settingsCreateVendorRaw(requestParameters: SettingsCreateVendorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IoTVendorResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ioTVendorPostModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add a vendor
     */
    async settingsCreateVendor(requestParameters: SettingsCreateVendorRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IoTVendorResponseModel> {
        const response = await this.settingsCreateVendorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete tenant affiliate for a specific country
     */
    async settingsDeleteTenantAffiliateAssignmentRaw(requestParameters: SettingsDeleteTenantAffiliateAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling settingsDeleteTenantAffiliateAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/tenant-affiliate-assignment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete tenant affiliate for a specific country
     */
    async settingsDeleteTenantAffiliateAssignment(requestParameters: SettingsDeleteTenantAffiliateAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.settingsDeleteTenantAffiliateAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a vendor
     */
    async settingsDeleteVendorRaw(requestParameters: SettingsDeleteVendorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.vendorId === null || requestParameters.vendorId === undefined) {
            throw new runtime.RequiredError('vendorId','Required parameter requestParameters.vendorId was null or undefined when calling settingsDeleteVendor.');
        }

        if (requestParameters.replacementVendorId === null || requestParameters.replacementVendorId === undefined) {
            throw new runtime.RequiredError('replacementVendorId','Required parameter requestParameters.replacementVendorId was null or undefined when calling settingsDeleteVendor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors/{vendorId}/{replacementVendorId}`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters.vendorId))).replace(`{${"replacementVendorId"}}`, encodeURIComponent(String(requestParameters.replacementVendorId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Remove a vendor
     */
    async settingsDeleteVendor(requestParameters: SettingsDeleteVendorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.settingsDeleteVendorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of customer types
     */
    async settingsGetCustomerTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerTypeModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/customer-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get list of customer types
     */
    async settingsGetCustomerTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerTypeModel>> {
        const response = await this.settingsGetCustomerTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of supported countries
     */
    async settingsGetSupportedCountriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IoTVendorResponseModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get list of supported countries
     */
    async settingsGetSupportedCountries(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IoTVendorResponseModel>> {
        const response = await this.settingsGetSupportedCountriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get tenant affiliates
     */
    async settingsGetTenantAffiliateAssignmentsRaw(requestParameters: SettingsGetTenantAffiliateAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantAffiliateResponseModel>>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/tenant-affiliate-assignment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get tenant affiliates
     */
    async settingsGetTenantAffiliateAssignments(requestParameters: SettingsGetTenantAffiliateAssignmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantAffiliateResponseModel>> {
        const response = await this.settingsGetTenantAffiliateAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tenant allocations
     */
    async settingsGetTenantAllocationsByFilterRaw(requestParameters: SettingsGetTenantAllocationsByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantAllocationsResponseModel>>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/tenant-allocations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get tenant allocations
     */
    async settingsGetTenantAllocationsByFilter(requestParameters: SettingsGetTenantAllocationsByFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantAllocationsResponseModel>> {
        const response = await this.settingsGetTenantAllocationsByFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Vendor\'s tenant allocation
     */
    async settingsGetTenantVendorAllocationRaw(requestParameters: SettingsGetTenantVendorAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IoTVendorTenantsResponseModel>> {
        if (requestParameters.vendorId === null || requestParameters.vendorId === undefined) {
            throw new runtime.RequiredError('vendorId','Required parameter requestParameters.vendorId was null or undefined when calling settingsGetTenantVendorAllocation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors/{vendorId}/tenant-allocation`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters.vendorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Vendor\'s tenant allocation
     */
    async settingsGetTenantVendorAllocation(requestParameters: SettingsGetTenantVendorAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IoTVendorTenantsResponseModel> {
        const response = await this.settingsGetTenantVendorAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of IoT vendors
     */
    async settingsGetVendorsRaw(requestParameters: SettingsGetVendorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IoTVendorResponseSimpleModel>>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get list of IoT vendors
     */
    async settingsGetVendors(requestParameters: SettingsGetVendorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IoTVendorResponseSimpleModel>> {
        const response = await this.settingsGetVendorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of IoT vendors available to being added, regardless their existence
     */
    async settingsGetVendorsCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IoTVendorCategoryResponseModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get list of IoT vendors available to being added, regardless their existence
     */
    async settingsGetVendorsCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IoTVendorCategoryResponseModel>> {
        const response = await this.settingsGetVendorsCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of IoT vendors with health checks
     */
    async settingsGetVendorsHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IoTVendorResponseModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors/health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get list of IoT vendors with health checks
     */
    async settingsGetVendorsHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IoTVendorResponseModel>> {
        const response = await this.settingsGetVendorsHealthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Associate tenants to vendor
     */
    async settingsTenantVendorAllocateRaw(requestParameters: SettingsTenantVendorAllocateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IoTVendorTenantsResponseModel>> {
        if (requestParameters.vendorId === null || requestParameters.vendorId === undefined) {
            throw new runtime.RequiredError('vendorId','Required parameter requestParameters.vendorId was null or undefined when calling settingsTenantVendorAllocate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors/{vendorId}/tenant-allocations`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters.vendorId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ioTVendorTenantPutModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Associate tenants to vendor
     */
    async settingsTenantVendorAllocate(requestParameters: SettingsTenantVendorAllocateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IoTVendorTenantsResponseModel> {
        const response = await this.settingsTenantVendorAllocateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tenant affiliate for a specific country
     */
    async settingsUpdateTenantAffiliateAssignmentRaw(requestParameters: SettingsUpdateTenantAffiliateAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantAffiliateResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling settingsUpdateTenantAffiliateAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/tenant-affiliate-assignment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.tenantAffiliateAddModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update tenant affiliate for a specific country
     */
    async settingsUpdateTenantAffiliateAssignment(requestParameters: SettingsUpdateTenantAffiliateAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantAffiliateResponseModel> {
        const response = await this.settingsUpdateTenantAffiliateAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a vendor
     */
    async settingsUpdateVendorRaw(requestParameters: SettingsUpdateVendorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IoTVendorPutModel>> {
        if (requestParameters.vendorId === null || requestParameters.vendorId === undefined) {
            throw new runtime.RequiredError('vendorId','Required parameter requestParameters.vendorId was null or undefined when calling settingsUpdateVendor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/settings/iot-vendors/{vendorId}`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters.vendorId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ioTVendorPutModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a vendor
     */
    async settingsUpdateVendor(requestParameters: SettingsUpdateVendorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IoTVendorPutModel> {
        const response = await this.settingsUpdateVendorRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
